import(/* webpackMode: "eager" */ "/app/apps/teacher/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/apps/teacher/src/app/loading.svg");
